module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c6a87046d9f91f59c572d486f146a05f.png";